// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"822cd032","239":"c003891a","455":"4fbe8e58"}[chunkId] + ".chunk.js";
};